export default __webpack_public_path__ + "static/media/5.d3f8d47c.png";